import React from 'react'

const Smoothen = ({ className }) => {
  return (
    <svg
      width={46}
      height={46}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={23} cy={23} r={23} fill="#B1B1B1" fillOpacity="0.22" />
      <path
        className="ac-s"
        d="M16 20L16.4651 19.4818C18.2083 17.5393 21.1768 17.3263 23.1795 19V19L23.3862 19.1728C25.3198 20.7887 28.1534 20.7147 30 19V19"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        className="ac-s"
        d="M16 24L16.3225 23.6407C18.1453 21.6096 21.2718 21.4057 23.3659 23.1558V23.1558C25.2995 24.7717 28.1534 24.7147 30 23V23"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        className="ac-s"
        d="M16 28L16.3225 27.6407C18.1453 25.6096 21.2718 25.4057 23.3659 27.1558V27.1558C25.2995 28.7717 28.1534 28.7147 30 27V27"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Smoothen
